/* eslint-disable no-console */
import type { AxiosResponse } from 'axios';

import type { UseMutateAsyncFunction } from 'react-query';

import client from 'state/remote/client';

import type { Success } from 'state/__generated__/tadaahAPI';
import { useApiAvailableAddCreate } from 'state/__generated__/tadaahAPI';

import type { ErrorType } from 'state/custom-instance';

const useAddAvailableDay = (
  onSuccessCallback?: () => void,
  onErroCallback?: () => void,
): {
  addAvailableDay: UseMutateAsyncFunction<
    AxiosResponse<Success, unknown>,
    ErrorType<unknown>,
    {
      date: string;
    },
    unknown
  >;
  isLoading: boolean;
  error: null | Error;
  isSuccess: boolean;
} => {
  const { mutateAsync, isLoading, error, isSuccess } = useApiAvailableAddCreate(
    {
      mutation: {
        mutationKey: 'add-available-day',
        onError: () => {
          onErroCallback?.();
        },
        onSuccess: () => {
          const queriesToInvalidate = [
            'get-available-single-call-jobs',
            'get-freelancer-available-time',
          ];
          queriesToInvalidate.forEach((query) => {
            client.invalidateQueries(query);
          });
          onSuccessCallback?.();
        },
      },
    },
  );

  return {
    addAvailableDay: mutateAsync,
    error,
    isLoading,
    isSuccess,
  };
};

export default useAddAvailableDay;
